import Modal from "../Modal";
import React from "react";
import styles from "./ExpiredInviteModal.module.css";

type Props = {
    label: string;
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    onSubmitLabel: string;
    buttonRef: React.MutableRefObject<null>;
};

const strings = {
    expiredModalText: "This invitation has expired. Would you like to start a new application?",
};

export default function ExpiredInviteModal(props: Props) {
    return (
        <Modal
            id="expiredInviteModal"
            label={props.label}
            isOpen={props.isOpen}
            onClose={props.onClose}
            onSubmit={props.onSubmit}
            onSubmitLabel={props.onSubmitLabel}
            triggerElement={props.buttonRef?.current}
        >
            <div className={styles.modalText}>{strings.expiredModalText}</div>
        </Modal>
    );
}
